import { Pipe, PipeTransform } from '@angular/core';

import { Session, SessionUtils } from '@optical/types';
import { convertDuration } from '@optical/utils';

@Pipe({
  name: 'sessionDuration',
})
export class SessionDurationPipe implements PipeTransform {
  transform(durationInSeconds: number): string;
  transform(session: Session): string;
  transform(value: number | Session): string {
    const duration = typeof value === 'number' ? value : SessionUtils.getDuration(value);

    return convertDuration(duration, {
      withSeconds: false,
      withSymbol: true,
    });
  }
}
